import { useEffect, useRef } from "react";
import Phaser from "phaser";
import TitleScene from "./scenes/TitleScene";
import TransitionScene from "./scenes/TransitionScene";
import OptionsScene from "./scenes/OptionsScene";
import CreditsScene from "./scenes/CreditsScene";
import TutorialScene from "./scenes/TutorialScene";
import MainScene from "./scenes/MainScene";
import ResultScene from "./scenes/ResultScene";
import LeaderboardScene from "./scenes/LeaderboardScene";
import RecoveryScene from "./scenes/RecoveryScene";
import HistoryScene from "./scenes/HistoryScene";

export default function Game() {
  const gameRef = useRef(null);

  useEffect(() => {
    if (gameRef.current) return;

    const config = {
      type: Phaser.AUTO,
      width: 800,
      height: 600,
      parent: "phaser-container",
      scale: {
        mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_BOTH,
      },
      physics: {
        default: "arcade",
        arcade: {
          gravity: { y: 475 },
        },
      },
      scene: [
        TitleScene,
        TransitionScene,
        OptionsScene,
        CreditsScene,
        TutorialScene,
        MainScene,
        LeaderboardScene,
        RecoveryScene,
        ResultScene,
        HistoryScene,
      ],
    };

    gameRef.current = new Phaser.Game(config);
  }, []);

  return <div id="phaser-container" className="w-[800px] h-[600px]" />;
}
